import React, { useMemo } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { CORES_GRAFICOS } from './constants';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

export default function GraficoCorretores({ corretores, isPesquisa, index }) {
  var chartData = useMemo(function() {
    if (!corretores || !corretores.length) return null;

    var labels = corretores.map(function(c) { return c.categoria; });
    var cadastros = corretores.map(function(c) { return c.cadastros; });
    var pastaCompleta = corretores.map(function(c) { return c.pasta_completa; });
    var pastaConferida = corretores.map(function(c) { return c.pasta_conferida; });
    var pontuacao = corretores.map(function(c) { return c.pontuacao; });

    var datasets = [
      {
        type: 'bar',
        label: 'Cadastros',
        data: cadastros,
        backgroundColor: CORES_GRAFICOS[index % CORES_GRAFICOS.length],
        stack: 'stack1',
        yAxisID: 'y',
        order: 3,
      },
      {
        type: 'bar',
        label: 'Pasta Completa',
        data: pastaCompleta,
        backgroundColor: CORES_GRAFICOS[(index + 1) % CORES_GRAFICOS.length],
        stack: 'stack1',
        yAxisID: 'y',
        order: 2,
      },
    ];

    if (isPesquisa) {
      datasets.push({
        type: 'bar',
        label: 'Pasta Conferida',
        data: pastaConferida,
        backgroundColor: CORES_GRAFICOS[(index + 2) % CORES_GRAFICOS.length],
        stack: 'stack1',
        yAxisID: 'y',
        order: 2,
      });
    }

    datasets.push({
      type: 'line',
      label: 'Pontuacao',
      data: pontuacao,
      borderColor: CORES_GRAFICOS[(index + 3) % CORES_GRAFICOS.length],
      backgroundColor: 'transparent',
      yAxisID: 'y',
      tension: 0.4,
      order: 1,
      pointRadius: 4,
      pointHoverRadius: 6,
    });

    return { labels: labels, datasets: datasets };
  }, [corretores, isPesquisa, index]);

  var options = useMemo(function() {
    return {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 3.5,
      interaction: { mode: 'index', intersect: false },
      plugins: {
        legend: {
          position: 'top',
          labels: { font: { size: 11 }, boxWidth: 12, padding: 10 },
        },
        tooltip: {
          callbacks: {
            label: function(context) {
              var label = context.dataset.label || '';
              var value = context.parsed.y;
              return label + ': ' + value;
            },
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: { font: { size: 10 }, maxRotation: 45, minRotation: 0 },
        },
        y: {
          stacked: true,
          type: 'linear',
          position: 'left',
          title: {
            display: true,
            text: 'Quantidade',
            font: { size: 11 },
          },
          ticks: { font: { size: 10 } },
        },
      },
    };
  }, []);

  if (!chartData) return null;

  return (
    <div style={{ maxWidth: '99%' }}>
      <Chart type="bar" data={chartData} options={options} />
    </div>
  );
}
